import { toMembershipDetailModel } from 'core/profile'
import { SmartClub } from 'tokyu-hooks'

export const QUERY_MEMBERSHIP_DETAIL_KEY = 'QUERY_MEMBERSHIP_DETAIL_KEY'

export const fetchMembershipDetail =
  (smartClubId?: number, accessToken?: string) => async () => {
    if (!accessToken || !smartClubId) return null

    const res = await SmartClub.getUserInfo({
      baseUrl: process.env.NEXT_PUBLIC_SMART_CLUB_URL as string,
      smartClubId: smartClubId,
      accessToken,
    })

    return toMembershipDetailModel(res?.data)
  }
